const DEFAULT_ERR_MSG = 'Something went wrong. Please try again later.'

const getError = (inputError = {}) => {
  if (inputError.data?.type) {
    return inputError.data
  }

  return inputError
}

// mostly used to get error message string from object
const parseErrorMessage = (defaultErrorMessage = DEFAULT_ERR_MSG) => {
  const getErrorMessge = (error) => {
    if (typeof error !== 'object') {
      return defaultErrorMessage
    }

    switch (error.type) {
      case 'VALIDATION_ERR': {
        const [validationError] = error.errors ?? []

        if (!validationError) {
          return defaultErrorMessage
        }

        switch (typeof validationError) {
          case 'string':
            return validationError
          case 'object':
            return getErrorMessge(validationError)
          default:
            return defaultErrorMessage
        }
      }

      // add here if required to return custom messages for given type
      case 'EXAMPLE_ERROR':
        return 'This is a custom message returned for type: EXAMPLE_ERROR'

      // if just needed to return server message. add here
      case 'USED_BY_BOTS':
      case 'BOT_ALREADY_EXISTS':
      case 'NO_DEFAULT_FLOW_DELETE':
      case 'DISPLAY_NAME_LENGTH_ERR':
      case 'INVALID_DISPLAY_NAME_TYPE':
      case 'INVALID_BRAND_COLOR':
      case 'INVALID_TEXT_COLOR':
      case 'INVALID_FILE_SIZE':
      case 'UNPROCESSABLE_FILE':
      case 'INVALID_EXTENSION':
      case 'INVALID_MIMETYPE':
      case 'ANSWER_ALREADY_EXISTS':
      case 'GUIDE_ALREADY_EXISTS':
      case 'INVALID_BADGE_LABEL':
      case 'BADGE_LABEL_LENGTH_ERR':
      case 'BADGE_LOGO_IMG_UNAVBL':
        return error.message || defaultErrorMessage

      default:
        return defaultErrorMessage
    }
  }

  return (inputError) => {
    const error = getError(inputError)
    return getErrorMessge(error)
  }
}

export default parseErrorMessage
